import { reactErrorHandler } from '@sentry/react';
import './index.css';
import './setup-yup';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/app';

createRoot(document.getElementById('root') as HTMLElement, {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <App></App>
  </StrictMode>,
);

// eslint-disable-next-line no-console
console.log(
  `%cVERSION%c${import.meta.env.NX_PUBLIC_APP_VERSION || 'development'}`,
  `
  border-radius: 4px 0 0 4px;
  background: #11ce8c;
  padding: 4px 8px;
  color: #fff;
  font-size: 24px;
  font-family: monospace;
  `,
  `
  border-radius: 0 4px 4px 0;
  background: #3d68ff;
  padding: 4px 8px;
  color: #fff;
  font-size: 24px;
  font-family: monospace;
  `,
);
